export default "__VITE_ASSET__cQ1uG7x6__"